let hyFirstName = {
  fieldId: "hyFirstName",
  fieldOptions: [],
  fieldTag: "name",
  label: "First Name*",
  type: "name",
}

let hyLastName = {
  fieldId: "hyLastName",
  fieldOptions: [],
  fieldTag: "name",
  label: "Last Name*",
  type: "name",
}


let hyPhone = {
  fieldId: "hyEmail",
  fieldOptions: [],
  fieldTag: "email",
  label: "Email*",
  type: "email",
}

let hyEmail = {
  fieldId: "hyPhone",
  fieldOptions: [],
  fieldTag: "phone",
  label: "Phone(s)*",
  type: "phones",
}

const defaultValues = [
  {
    fieldDetails: hyFirstName,
    required: true
  },
  {
    fieldDetails: hyLastName,
    required: true
  },
  {
    fieldDetails: hyPhone,
    required: true
  },
  {
    fieldDetails: hyEmail,
    required: true
  }
]

const defaultOptions = [hyFirstName, hyLastName, hyPhone, hyEmail]

const getInitialValues = (formFields, fields) => {
  if (fields.length === 0) {
    return defaultValues
  }
  let initialValues = [];
  for (let i = 0; i < fields.length; i++) {
    let fieldDetails = fields[i].split('_');
    let _fields = formFields.find(e => e.fieldId === fieldDetails[0])
    if (_fields) {
      initialValues.push({
        fieldDetails: _fields,
        required: fieldDetails[1] === "required" ? true : false
      })
    }
  }
  return [...defaultValues, ...initialValues]
}

const filterOption = (_list, fieldArray, index) => {
  let list = [...defaultOptions, ..._list]
  return list.filter((i, idx) => {
    let selected = fieldArray.find((j, idx1) => {
      return idx1 !== index && j.fieldDetails.fieldId == i.fieldId
    })
    return selected ? false : true;
  })
}

export {
  getInitialValues,
  filterOption,
  defaultValues,
}